module.exports = __webpack_public_path__ + "img/arw.9b2a5477.svg";